/** Format of the two editable date inputs of the period popover, also used as their placeholder. */
export const INPUT_DATE_FORMAT = 'DD/MM/YYYY';
